module.exports = __webpack_public_path__ + "img/fruit-cantaloupe-190x100.45171a92.jpg";